var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"flex items-center px-2 py-1 rounded"},[_c('div',{staticClass:"h-3 w-3 rounded-full mr-2",style:({
			backgroundColor: _vm.chipColor(_vm.params.value),
		})}),_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v(_vm._s(_vm.params.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }